export default __webpack_public_path__ + "3c2a2e9c0977c7521962a916b982bfba.svg";